import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, MoveLeft, LayoutDashboard } from 'lucide-react';
import SEO from "../components/SEO";

const NotFound = () => {
    const location = useLocation();
    const isAdminRoute = location.pathname.startsWith('/admin');

    return (
        <div className="min-h-screen bg-[#FDFDFD] dark:bg-[#0A0A0A] flex items-center justify-center p-6 relative overflow-hidden">
            <SEO title="Page Not Found" description="The requested page could not be found." />
            {/* Background accents */}
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-jazz-brown/5 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/2" />
            <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-jazz-brown/5 rounded-full blur-[120px] translate-y-1/2 -translate-x-1/2" />

            <div className="max-w-md w-full text-center relative z-10">
                {/* Error Code */}
                <div className="mb-8">
                    <h1
                        className="text-[120px] font-bold text-jazz-brown opacity-20 leading-none select-none"
                        style={{ fontFamily: 'Playfair Display, serif' }}
                    >
                        404
                    </h1>
                    <div className="mt-[-60px]">
                        <h2
                            className="text-3xl font-normal text-[#111111] dark:text-white mb-4"
                            style={{ fontFamily: 'Playfair Display, serif' }}
                        >
                            Page Not Found
                        </h2>
                        <div className="w-12 h-1 bg-jazz-brown mx-auto mb-6" />
                    </div>
                </div>

                {/* Message */}
                <p className="text-black/70 dark:text-[#A0A0A0] font-inter text-sm leading-relaxed mb-10 italic px-4">
                    {isAdminRoute
                        ? "The administrative tool you're looking for seems to have been misplaced."
                        : "The melody you're looking for seems to have drifted away."}
                    <br />
                    The page may have been moved or deleted.
                </p>

                {/* Actions */}
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <Link
                        to={isAdminRoute ? "/admin/dashboard" : "/"}
                        className="w-full sm:w-auto px-8 py-4 bg-[#111111] dark:bg-white text-white dark:text-[#111111] rounded-xl flex items-center justify-center gap-2 font-inter text-xs font-bold uppercase tracking-[2px] hover:bg-jazz-brown dark:hover:bg-jazz-brown dark:hover:text-white transition-all duration-300 shadow-lg"
                    >
                        {isAdminRoute ? <LayoutDashboard size={16} /> : <Home size={16} />}
                        {isAdminRoute ? "Back to Dashboard" : "Back to Home"}
                    </Link>

                    <button
                        onClick={() => window.history.back()}
                        className="w-full sm:w-auto px-8 py-4 bg-white dark:bg-[#1A1A1A] text-[#111111] dark:text-white border border-[#E5E7EB] dark:border-[#2A2A2A] rounded-xl flex items-center justify-center gap-2 font-inter text-xs font-bold uppercase tracking-[2px] hover:border-jazz-brown hover:text-jazz-brown transition-all duration-300"
                    >
                        <MoveLeft size={16} />
                        Go Back
                    </button>
                </div>

                {/* Brand Footer */}
                <div className="mt-16 pt-8 border-t border-black/5 dark:border-white/5">
                    <p className="text-[10px] text-black/60 dark:text-[#666666] font-inter uppercase tracking-widest font-bold">
                        Temidayo Balogun
                    </p>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
